import React, { useState } from "react";

import DropdownMenu from "../DropdownMenu";
import { Dropdown, DropdownContent, DropdownItem } from "../../BaseUI/Dropdown";

import { MdExpandMore } from "react-icons/md";

import styles from "./CardContainer.module.scss";

export default function CardContainer({
  title,
  children,
  actions,
  headerAction,
  filters,
  className,
  onFiltered,
  style,
  fillHeight = false,
}) {
  const [defaultFilter, setDefaultFilter] = useState(filters?.[0]?.label || "");

  const containerStyle = fillHeight
    ? { display: "flex", flexDirection: "column", height: "100%", flex: 1, minHeight: 0, ...style }
    : style;

  const contentStyle = fillHeight
    ? { flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }
    : { height: "77%" };

  return (
    <div className={styles["card-container"]} style={containerStyle}>
      {(title || actions || headerAction || filters?.length > 0) && (
        <div className={styles["card-container__header"]}>
          <div className={styles["card-container__header--title"]}>{title}</div>
          <div className={styles["card-container__header--action"]}>
            {headerAction}
            {actions?.length > 0 && <DropdownMenu options={actions} />}

            {filters?.length > 0 && (
              <Dropdown
                trigger={
                  <div className={styles["filter-dropdown"]}>
                    <span>{defaultFilter}</span>
                    <MdExpandMore />
                  </div>
                }
                placement="top-end"
                hideDropdownIcon={true}
              >
                <DropdownContent>
                  {filters?.map(({ label, value }, index) => (
                    <DropdownItem
                      key={index}
                      onClick={() => {
                        onFiltered?.(value);
                        setDefaultFilter(label);
                      }}
                    >
                      {label}
                    </DropdownItem>
                  ))}
                </DropdownContent>
              </Dropdown>
            )}
          </div>
        </div>
      )}
      <div
        className={`${styles["card-container__content"]}  ${className}`}
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
}
